/**
 * Startet eine Aufgabe erst, wenn der Hauptthread frei ist oder der Nutzer
 * das erste Mal interagiert. Hält Drittanbieter-Skripte aus dem kritischen
 * Ladepfad und verbessert damit LCP, TBT und INP.
 */
export function whenIdleOrInteraction(task: () => void, timeout = 4000) {
  if (typeof window === "undefined") return;

  let done = false;
  const events = ["pointerdown", "keydown", "touchstart", "scroll"] as const;

  const run = () => {
    if (done) return;
    done = true;
    events.forEach((e) => window.removeEventListener(e, run));
    task();
  };

  events.forEach((e) => window.addEventListener(e, run, { once: true, passive: true }));

  const ric = (window as unknown as {
    requestIdleCallback?: (cb: () => void, o?: { timeout: number }) => void;
  }).requestIdleCallback;

  if (ric) ric(run, { timeout });
  else window.setTimeout(run, timeout);
}
